<template>
  <div
    class="videoArea-container"
    :class="{ 'video-full-container': isFullScreen }"
    @mouseenter.stop="changeShow(true)"
    @mouseleave.stop="changeShow(false)"
    @mousemove.stop="move"
  >
    <!-- webrtc显示 -->
    <div
      v-if="!isShowNodePlayer"
      :class="[
        videoPostion.live.class,
        !videoPostion.live.isShow ? 'show_video' : '',
      ]"
    >
      <video
        ref="liveRef"
        id="live"
        autoplay
        :width="videoPostion.live.width"
        :height="videoPostion.live.height"
        class="borderRadius4"
      ></video>
    </div>
    <!-- 三方播放 -->
    <div
      :style="{
        width: videoPostion.live.width,
        height: videoPostion.live.height,
      }"
      v-if="isShowNodePlayer"
      :class="[videoPostion.live.class, !videoPostion.live.isShow ? 'show_video' : '']"
      :id="videoPostion.live.class"
    >
      <Vue263player
        ref="VueAliplayerV2"
        :roomOptions="playerConfig.roomOptions"
        :source="playerConfig.source"
        :audioSource="playerConfig.audioSource"
        :options="playerConfig.options"
        :isNodePlayer="playerConfig.isNodePlayer"
        :nodePlayerWasmUrl="playerConfig.nodePlayerWasmUrl"
        @play="onPlay"
        :style="{
          width: videoPostion.live.width,
          height: videoPostion.live.height,
        }"
      >
      </Vue263player>
    </div>
    <!-- 鼠标悬浮显示操作 -->
    <div
      class="over-control"
      v-if="showControl"
      :class="{ 'full-control': isFullScreen || ischangearea }"
    >
      <!-- 扬声器显示 -->
      <div
        class="live-speaker pointer"
        :class="{ 'fullscreen-speaker': isFullScreen || ischangearea }"
        @click.stop="changeSpeakerStatus"
        v-if="
          videoPostion.live.class != 'videoArea-position2' &&
          liveStartStatus === 2
        "
      >
        <el-tooltip
          :content="$t('video.扬声器已开启')"
          placement="top-start"
          v-if="!closeSpeaker"
        >
          <img :src="require('@/svg/speaker-small.svg')" />
        </el-tooltip>
        <el-tooltip
          :content="$t('video.扬声器已关闭')"
          placement="top-start"
          v-if="closeSpeaker"
        >
          <img :src="require('@/svg/speaker-small-close.svg')" />
        </el-tooltip>
      </div>
      <!-- 全屏按钮 -->
      <div
        v-if="videoPostion.live.class == 'videoArea-position1'"
        class="video-fullscreen pointer"
        :class="{ 'fullscreen-exit': isFullScreen || ischangearea }"
        @click.stop="fullScreen"
      >
        <el-tooltip
          :content="$t('video.全屏')"
          placement="top-start"
          v-if="!isFullScreen"
        >
          <img :src="require('@/svg/video_fullscreen.svg')" />
        </el-tooltip>
        <el-tooltip
          :content="$t('video.退出全屏')"
          placement="top-start"
          v-else
        >
          <img :src="require('@/svg/video_exitfull.svg')" />
        </el-tooltip>
      </div>
    </div>
    <audioProcess :class="{ 'full-control-audio': showControl &&( isFullScreen || ischangearea) }"/>
    <!-- <LianmaiTips v-if="role !== 3 && isFullScreen" /> -->
  </div>
</template>

<script>
const Resolutions = [
  {
    width: 1920,
    height: 1080,
  },
  {
    width: 1280,
    height: 720,
  },
  {
    width: 640,
    height: 360,
  },
];
import { pushRoomMessageFunc, removeMessageFunc } from "@/utils/socketMessageDispose";
import { pushStreamUrl } from "@/api/liveRequest/login";
import Bus from "../doc/bus";
import Role from "@/mixins/role";
import { device, fullScreen, exitFullscreen } from "@/utils/global";
// import LianmaiTips from "@/components/lianmai/tips.vue";
import audioProcess from "@/components/local/audioProcess.vue";
import { mapGetters } from "vuex";
import { sysInfo } from '@/utils/global';
export default {
  name: "videoArea",
  components: {
    audioProcess
  },
  mixins: [Role],
  computed: {
    ...mapGetters(["liveConfig", "micDefault", "cameraResolution","defaultSource"]),
    shareType() {
      return this.$store.getters.shareType;
    },
    signalStatus() {
      return this.$store.getters.signalStatus;
    },
    pseudoLiveInfo() {
      return this.$store.getters.pseudoLiveInfo;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    videoInputDeviceId() {
      return this.$store.getters.VideoInputDeviceId
        ? this.$store.getters.VideoInputDeviceId
        : true;
    },
    AudioOutputDeviceId() {
      return this.$store.getters.AudioOutputDeviceId;
    },
    AudioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId
        ? this.$store.getters.AudioInputDeviceId
        : true;
    },
    selfVideoStatus() {
      return this.$store.getters.selfVideoStatus;
    },
    selfAudioStatus() {
      return this.$store.getters.selfAudioStatus;
    },
    audioStatus() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.mediaStatus &&
        this.$store.getters.selfParticipant.mediaStatus.audio
      );
    },
    videoStatus() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.mediaStatus &&
        this.$store.getters.selfParticipant.mediaStatus.video
      );
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    /**
     * 直播是否开启 // 0  未开始  1; // 准备中  2; // 直播中  3; // 已过期
     */
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    pushStreamStatus() {
      return this.$store.getters.pushStreamStatus;
    },
    curPlayStatus() {
      return (
        (this.$refs.VueAliplayerV2 &&
          this.$refs.VueAliplayerV2.curPlayStatus) ||
        "pause"
      );
    },
    shareStream() {
      return this.rtcClient.RTCRoom && this.rtcClient.RTCRoom.shareStream;
    },
    authAudio() {
      //0:主控模式 1：自由
      return (
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.audio
      );
    },
    authVideo() {
      //0:主控模式 1：自由
      return (
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    isCheck() {
      return this.$store.getters.isCheck;
    },
    opType() {
      return this.$store.getters.opType;
    },
    streamStatus() {
      return this.$store.getters.streamStatus;
    },
    avctl() {
      //    // 主控权   1：有  0：无
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.avctl
      );
    },
    selfType() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    isPackUp() {
      return this.$store.getters.isPackUp;
    },
    ischangearea() {
      return this.$store.getters.isChangeArea;
    },
    used() {
      return this.$store.getters.used;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    isLeave() {
      return this.$store.getters.isLeave;
    },
    live2Stream() {
      return (
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.remoteMixStream &&
        this.rtcClient.RTCRoom.remoteMixStream.find((info) => {
          return info.id.split("-")[1] == "live2";
        })
      );
    },
    webrtc() {
      let webrtc = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc
      ) {
        webrtc = this.rtcClient.RTCRoom.webrtc;
      }
      return webrtc;
    },
    getCameraResolution() {
      return this.cameraResolution == 1080
        ? { width: 1920, height: 1080 }
        : this.cameraResolution == 360
        ? { width: 640, height: 360 }
        : { width: 1280, height: 720 };
    },
    watchGroup() {
      return [this.$store.getters.opType, this.$store.getters.streamStatus, this.$store.getters.used];
    }
  },
  watch: {
    // shareType: {
    //   handler(value) {
    //     if(value === 2 || value === 3){

    //     }
    //   },
    // },
    "$store.getters.isCheck": {
      handler(value) {
        if (!value) {
          if (this.pseudoLiveInfo) {
            this.pseudoLiveData = JSON.parse(this.pseudoLiveInfo);
          }
          console.log('selectPlayStyle isCheck')
          this.selectPlayStyle();
          //如果是预约主播源，发布视频，否则获取直播源
          //if(this.defaultSource == 0){
            this.init();
          //} else {
           // this.getLivePlayInfo();
          // }
          if (this.shareType === 2 || this.shareType === 4) {
            this.isShowNodePlayer = false;
            this.getLiveStream();
          }
        }
      },
      deep: true,
    },
    "$store.getters.liveRoomStatus": {
      handler() {
        // this.selectPlayStyle();
        // if (value == 2 && this.shareType != 4 && !this.isCheck) {
        //   this.isShowNodePlayer = false;
        //   this.getLiveStream();
        // } else if (value == 2 && this.shareType == 4) {
        //   this.getLivePlayInfo();
        // } else {
        //   this.stopSubLive();
        // }
      },
      deep: true,
    },
    "$store.getters.pushStreamStatus": {
      handler: function (newVal) {
        if (`${newVal}` === `1`) {
          // this.playerConfig.source = null;
          this.stopVuePlayer();
        } else {
          console.log('selectPlayStyle pushStreamStatus')
          this.selectPlayStyle();
        }
      },
      immediate: true,
    },
    shareStream: {
      handler(value) {
        if (value && this.videoPostion.live.class == "videoArea-position2") {
          this.handelVideo(this.videoPostion.local, "change");
        }
      },
      immediate: true,
    },
    // watchGroup: {
    //   handler() {
    //     console.log("watchGroup selectPlayStyle");
    //     this.selectPlayStyle();
    //   },
    //   immediate: true,
    // },
    opType: {
      handler() {
        console.log('selectPlayStyle opType')
        this.selectPlayStyle();
      },
      immediate: true,
    },
    used: {
      handler() {
        console.log('selectPlayStyle used')
        this.selectPlayStyle();
      },
      immediate: true,
    },
    streamStatus: {
      handler() {
        console.log('selectPlayStyle streamStatus')
        this.selectPlayStyle();
      },
      immediate: true,
    },
    ischangearea: {
      handler(val) {
        this.setVideo2Size(
          val ? "220px" : "89px",
          val ? "122px" : "51px",
          val ? "100%" : "250px",
          val ? "100%" : "141px"
        );
      },
      immediate: true,
    },
    isFullScreen: {
      handler(val) {
        if (this.ischangearea && !val) {
          console.log(this.fullSize);
          this.setVideo2Size("219px", "121px", "99.9%", "99.9%");
          return;
        }
        this.setVideo2Size(
          val ? "220px" : "89px",
          val ? "122px" : "51px",
          val ? "100%" : "250px",
          val ? "100%" : "141px"
        );
      },
      immediate: true,
    },
    isLeave: {
      handler(val) {
        if (val) {
          console.log('videoArea watch leave clear timers');
          this.clearRecollectTimer();
          this.clearSubLiveTimer();
          this.clearPubLoaclTimer();
        }
      },
      immediate: true,
    },
    live2Stream: {
      handler(val) {
        if (val) {
          console.log(val);
          console.log('selectPlayStyle live2Stream')
          this.selectPlayStyle();
        }
      },
    },
    videoStatus: {
      handler(val) {
        if (val && this.publishStream && this.publishStream.getVideoTracks()[0]) {
          this.publishStream.getVideoTracks()[0].enabled =
            val == "active" ? true : false;
        }
      },
    },

    // signalStatus() {
    //    this.setSendResolution();
    // },
  },
  data() {
    return {
      getReceiverCsrcWorker: null,
      getReceiverCsrcTimer: null,
      isDestry: false,
      device: device(),
      isShowNodePlayer: false,
      playerConfig: {
        roomOptions: {
          streamType: null,
        },
        source: null,
        audioSource: null,
        options: {
          isLive: true, //切换为直播流的时候必填
          autoplay: true, //播放器是否自动播放
          rePlay: true, // 播放器自动循环播放。
          playsinline: true, //H5是否内置播放。
          preload: true, //自动加载
          controlBarVisibility: "hover",
          useH5Prism: true,
          mediaType: "video",
          extraInfo: {
            //移动端添加。
            "x5-video-player-type": "h5" /*启用H5播放器,是wechat安卓版特性*/,
          },
        },
        isNodePlayer: true,
        nodePlayerWasmUrl: null,
      },
      liveStream: null,
      isSubing: null,
      videoPostion: {
        local: {
          width: "89px",
          height: "51px",
          class: "videoArea-position2",
          name: "本地",
          isShow: false,
        },
        live: {
          width: "250px",
          height: "141px",
          class: "videoArea-position1",
          name: "Live",
          isShow: true,
        },
      },
      preQuality: null,
      preUrl: null,
      playUrls: null,
      videoOrAudio: 0,
      isFullScreen: false,
      pseudoLiveData: null,
      closeSpeaker: false, //是否关闭扬声器
      recollectTimer: null,
      recollectTimeCount: 0,
      liveSubScription: null,
      localPublication: null,
      subLiveReconnect: {
        timer: null,
        time: 0,
        seq: 0
      }, //直播流重连，10s重连一次
      publishLocalReconnect: {
        timer: null,
        time: 0,
        seq: 0
      }, //本地流重连，10s重连一次
      showControl: false, //是否显示操作按钮
      maxResolution: {
        height: 1080,
        width: 1920,
      },
      mouseY: 0,
      oldMouseY: 0,
      chooseMaxBitrate: 600000, //发布视频的分辨率
      shareDesk: false, //是否共享屏幕
      joinRoomSuccess: false,
      isThirdStream: false
    };
  },
  mounted() {
    this.loadNedePlayerWasm();
    //收到聊天室消息
    pushRoomMessageFunc(this.getCvMcRoomMessage);
    this.addEvent();

    Bus.$on("mediaSelectPicQuality", this.updatePicQuality);
    Bus.$on("addVideoTrackEvent", this.addVideoTrackEvent);
    Bus.$on("addAudioTrackEvent", this.addAudioTrackEvent);
    //监听是否降分辨率
    Bus.$on("scaleBitrate", this.scaleBitrate);
    Bus.$on("closeShareLayout", this.closeShareLayout);
  },
  beforeDestroy() {
    console.log('videoArea beforeDestroy clear');

    this.isDestry = true;
    removeMessageFunc(this.getCvMcRoomMessage);

    this.clearRecollectTimer();
    this.clearSubLiveTimer();
    this.clearPubLoaclTimer();

    Bus.$off("onPublicLocalended", this.RePub);
    Bus.$off("onRelogin", this.RePub);
    Bus.$off("stopSubLive", this.stopSubLive);
    Bus.$off("mediaSelectPicQuality", this.updatePicQuality);
    Bus.$off("addVideoTrackEvent", this.addVideoTrackEvent);
    Bus.$off("addAudioTrackEvent", this.addAudioTrackEvent);
    Bus.$off("scaleBitrate");
    Bus.$off("closeShareLayout");

    [
      "fullscreenchange",
      "webkitfullscreenchange",
      "mozfullscreenchange",
    ].forEach((item) => {
      window.removeEventListener(item, this.fullscreenchange);
    });
  },
  methods: {
    move(e) {
      if (this.isFullScreen) {
        this.timeShow();
        this.mouseY = e.clientY;
        if (this.oldMouseY !== this.mouseY) {
          this.oldMouseY = this.mouseY;
          this.showControl = true;
        }
        // console.log(e.clientY);
      }
    },
    changeShow(val) {
      if (!this.ischangearea && this.isShowNodePlayer) {
        return;
      }
      this.showControl = val;
    },
    timeShow() {
      setTimeout(() => {
        if (this.oldMouseY === this.mouseY) {
          this.showControl = false;
        }
      }, 3000);
    },
    setRecollectTimer() {
      console.log('setRecollectTimer01', {resubTimer: this.subLiveReconnect.timer, repubTimer: this.publishLocalReconnect.timer});
      this.clearRecollectTimer();

      if (this.isLeave || this.isDestry)
        return;

      console.log('setRecollectTimer02');
      console.log("%c 重连中", "color:red;font-size:16px");

      this.recollectTimer = setInterval(() => {
        if (this.isDestry) {
          this.clearRecollectTimer();
          return;
        }

        this.recollectTimeCount++;
        console.log(
          'setRecollectTimer interval callback',
          ' ,this.subLiveReconnect', this.subLiveReconnect.timer,
          ',this.publishLocalReconnect.timer', this.publishLocalReconnect.timer,
          ' ,recollectTimeCount:', this.recollectTimeCount
        );

        if (
          this.subLiveReconnect.timer
          && this.liveSubScription && this.liveSubScription.getConnectionState
          && this.liveSubScription.getConnectionState() == "connected"
        ) {
          console.log(
            "%c 重新订阅live流成功",
            "color:green;font-size:16px"
          );
          this.clearSubLiveTimer();
          this.logger.info({code: 2057,message: "订阅live流成功"});
        }

        if (
          this.publishLocalReconnect.timer
          && this.localPublication && this.localPublication.getConnectionState
          && this.localPublication.getConnectionState() == "connected"
        ) {
          console.log(
            "%c 重新发布流成功",
            "color:green;font-size:16px"
          );
          this.clearPubLoaclTimer();
          this.logger.info({code: 2058,message: "发布live流成功"});
        }

        if (this.isSubing || this.subLiveReconnect.timer) {
          if (
            this.localPublication &&
            this.localPublication.getConnectionState &&
            this.liveSubScription &&
            this.liveSubScription.getConnectionState
          ) {
            if (
              this.localPublication.getConnectionState() == "connected" &&
              this.liveSubScription.getConnectionState() == "connected"
            ) {
              console.log("%c 重连成功", "color:green;font-size:16px");
              this.clearRecollectTimer();
            }
          }
        } else {
          if (
            this.localPublication &&
            this.localPublication.getConnectionState
          ) {
            if (this.localPublication.getConnectionState() == "connected") {
              console.log("%c 重连成功", "color:green;font-size:16px");
              this.clearRecollectTimer();
            }
          }
        }

        if (this.recollectTimeCount > 60) {

          console.log("%c recollectTimeCount 超过60次, 无法与直播流服务器取得连接, exitRoom", "color:red;font-size:16px")
          this.clearRecollectTimer();
          this.clearSubLiveTimer();
          this.clearPubLoaclTimer();
          Bus.$emit("exitRoom", this.$t("video.无法与直播流服务器取得连接"));
          this.logger.error({code: 2060,message: "60次失败,无法与直播流服务器取得连接,退出房间"});
        }
      }, 1000);
    },
    clearRecollectTimer() {
      console.log('clearRecollectTimer, this.recollectTimer:', this.recollectTimer);
      this.recollectTimer && clearInterval(this.recollectTimer);
      this.recollectTimer = null;
      this.recollectTimeCount = 0;
    },
    clearSubLiveTimer() {
      console.log('clearSubLiveTimer, this.subLiveReconnect.timer:', this.subLiveReconnect.timer);
      if (this.subLiveReconnect.timer) {
        clearInterval(this.subLiveReconnect.timer);
        this.subLiveReconnect.timer = null;
      }
    },
    clearPubLoaclTimer() {
      console.log('clearPubLoaclTimer, this.publishLocalReconnect.timer:', this.publishLocalReconnect.timer);
      if (this.publishLocalReconnect.timer) {
        clearInterval(this.publishLocalReconnect.timer);
        this.publishLocalReconnect.timer = null;
      }
    },
    addEvent() {
      Bus.$on("onPublicLocalended", this.RePub);
      Bus.$on("onRelogin", this.RePub);
      Bus.$on("onRePub", this.pubLiveStream)
      Bus.$on("onReSub", this.subLiveStream);
      Bus.$on("stopSubLive", this.stopSubLive);
      // 全屏监听
      [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange",
      ].forEach((item) => {
        window.addEventListener(item, this.fullscreenchange);
      });
    },
    pubLiveStream() {
      //重新发布流
     console.log(this.rtcClient.RTCRoom.webrtc.publishShare.shareStream, "重新发布流")
     console.log(this.shareType, '共享状态')
      if(this.shareType === 2) {
        //TODO 有共享的需要刷新页面
        this.$alert(this.$t("video.请刷新"), {
            title: this.$t("video.网络异常"),
            customClass: "tip-alert text-left",
            confirmButtonText: this.$t("video.知道了"),
            callback: () => {
              const url = window.location.href;
              window.location.href = url;
            },
          });
          // let config = {
          //   audio: true,
          //   video: {
          //     source: "screen-cast",
          //     frameRate: 15,
          //     resolution: {
          //       width: 1920,
          //       height: 1080,
          //     },
          //   },
          // };

          // this.rtcClient.RTCRoom.publishShareScreen(config)
          //   .then((res) => {
          //     console.log(res, "返回共享.....");
          //   //TODO 判断改流
          //     //this.layoutStreams();

          //     this.$store.commit("SET_SHARE_TYPE", 2);
          //     if (res.stream && res.stream.id) {
          //       Bus.$emit("startShare");
          //       ["ended", "error"].forEach((i) => {
          //         console.log('分辨率 ended......');
          //         res.publication.addEventListener(i, () => {

          //           Bus.$emit("closeShare");
          //         });
          //       });
          //       //this.getDisplayMediaError("success");
          //     } else {
          //       console.log(res.stream.info.name, "res.info.name");
          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error, "捕获共享错误");
          //     this.$message.error(this.$t("aside-left.您的浏览器不支持使用桌面共享功能"));
          //   });
      }
      this.init()
      this.logger.info({code: 2063,message: "重新发布流"});
   },
    subLiveStream() {
      console.log("重新订阅流")
      //if (this.shareType === 2 || this.shareType === 4) {
       // this.isShowNodePlayer = false;
       console.log(this.isShowNodePlayer, '是否存在第三方推流');
       //如果是三方流无需订阅
       if(!this.isShowNodePlayer){
        this.reGetLiveStream(false);
        this.logger.info({code: 2064,message: "重新订阅流"});
       }
      //}
      // this.getLiveStream()
    },
    async reGetLiveStream(isForceSub) {
      if (this.isLeave || this.isDestry) {
        return;
      }

      const quality = await this.getQuality();
      console.log('重新订阅....')
      if (this.rtcClient.RTCRoom && this.rtcClient.RTCRoom.remoteMixStream) {
        const liveStream = this.rtcClient.RTCRoom.remoteMixStream.find(
          (info) => {
            return info.id.split("-")[1] == "live2";
          }
        );

        console.log(liveStream, 'liveStream')

        console.log(this.isSubing, "this.isSubing", ' ,isForceSub:', isForceSub);
        if (liveStream && (!this.isSubing || isForceSub)) {
          this.maxResolution = liveStream.settings.video.resolution;
          this.isSubing = true;
          this.preQuality = quality;
          console.warn(quality, "quality");
          const params = quality.width
            ? {
                resolution: quality,
              }
            : {
                resolution: {
                  width: this.maxResolution.width,
                  height: this.maxResolution.height,
                },
              };
          const codecsName = this.device.isFireFox ? "vp8" : "h264";

            if (this.liveSubScription && this.liveSubScription.stop) {
              this.liveSubScription.stop();
            }

            const reqSeq = ++this.subLiveReconnect.seq;
            console.log('this.rtcClient.RTCRoom.subscribeStream reqSeq:',  reqSeq);
            this.rtcClient.RTCRoom.subscribeStream(
              liveStream,
              { codecs: [{ name: codecsName }], ...params },
              true
            )
              .then((res) => {
                if (this.isLeave || this.isDestry) {
                  this.clearSubLiveTimer();
                  return;
                }

                if (reqSeq !== this.subLiveReconnect.seq) {
                  console.log('reqSeq !== this.subLiveReconnect.seq, reqSeq:', reqSeq, ' ,this.subLiveReconnect.seq:', this.subLiveReconnect.seq);
                  res.subscription && res.subscription.stop && res.subscription.stop();
                  return;
                }

                this.logger.info({ code: 2031, message: res });
                this.isSubing = false;
                this.liveStream = res;
                const eventName = ["error", "ended"];

                if (this.liveSubScription) {
                  console.log('remove liveSubScription', this.liveSubScription.id);
                  eventName.forEach((event) => {
                    this.liveSubScription.clearEventListener(`${event}`)
                  });
                  this.liveSubScription = undefined;
                }

                this.$store.commit("SET_SHARESUBSCRIPTION", res.subscription);
                this.liveSubScription = res.subscription;
                console.log('set liveSubScription', this.liveSubScription.id, this.subLiveReconnect.timer);
                document.getElementById("live").srcObject = res.stream.mediaStream;

                eventName.forEach((event) => {
                  res.subscription.addEventListener(`${event}`, () => {
                    if (this.isLeave || this.isDestry) {
                      this.clearSubLiveTimer();
                      return;
                    }
                    console.log(
                      "%c 订阅live流重连, 因为接收到事件:" + event + ",recollectTimeCount:" + this.recollectTimeCount,
                      "color:red;font-size:16px"
                    );

                    if (!this.recollectTimer) {
                      this.setRecollectTimer();
                    }

                    // 订阅流重连
                    this.clearSubLiveTimer();
                    this.subLiveReconnect.timer = setInterval(async () => {
                      if (this.isDestry) {
                        this.clearSubLiveTimer();
                        return;
                      }

                      console.log(
                        "trigger subLiveReconnect timer callback",
                        this.liveSubScription && this.liveSubScription.getConnectionState && this.liveSubScription.getConnectionState()
                      );

                      if (
                        this.liveSubScription &&
                        this.liveSubScription.getConnectionState
                      ) {
                        if (this.liveSubScription.getConnectionState() != "connected") {
                          //debugger
                          console.log(
                            "%c 10s后重新订阅live流中" + ",recollectTimeCount:" + this.recollectTimeCount,
                            "color:red;font-size:16px"
                          );
                          this.getLiveStream(true);
                        } else {
                          this.clearSubLiveTimer();
                        }
                      }
                    }, 10000);

                    console.log('getLiveStream set this.subLiveReconnect.timer', this.subLiveReconnect.timer);
                  });
                });
              })
              .catch((err) => {
                this.logger.info({ code: 2032, message: err });
                console.log(err, "订阅失败");
                this.subOrPubErrTips();
              });

        }
      }
    },
    RePub() {
      if (this.isLeave || this.isDestry) {
        this.clearPubLoaclTimer();
        return;
      }

      console.log("%c 发布流重连" + ",recollectTimeCount:" + this.recollectTimeCount, "color:red;font-size:16px");

      if (!this.recollectTimer) {
        this.setRecollectTimer();
      }

      //发布流重连
      console.log('RePub this.publishLocalReconnect.timer', this.publishLocalReconnect.timer);
      this.clearPubLoaclTimer();
      this.publishLocalReconnect.timer = setInterval(async () => {
        if (this.isLeave || this.isDestry) {
          this.clearPubLoaclTimer();
          return;
        }

        console.log(
          "trigger publishLocalReconnect timer callback",
          this.publishLocalReconnect.timer,
          this.localPublication && this.localPublication.getConnectionState && this.localPublication.getConnectionState()
        );

        if (this.localPublication && this.localPublication.getConnectionState) {
          if (this.localPublication.getConnectionState() != "connected") {
            console.log("%c 10s后重新发布流中" + ",recollectTimeCount:" + this.recollectTimeCount, "color:red;font-size:16px");
            this.init();
            this.logger.info({ code: 2050, message: "重新发布流中重连" });
          } else {
            this.clearPubLoaclTimer();
          }
        }
      }, 10000);
    },
    fullscreenchange() {
      this.isFullScreen = this.checkFull();
    },
    checkFull() {
      let isFull =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (isFull === undefined || isFull == null) {
        console.log("非全屏状态");
        isFull = false;
      } else {
        isFull = true;
      }
      return isFull;
    },

    setVideo2Size(width1, height1, width2, height2) {
      for (let key in this.videoPostion) {
        if (this.videoPostion[key].class == "videoArea-position2") {
          this.videoPostion[key].height = height1;
          this.videoPostion[key].width = width1;
        }
        if (this.videoPostion[key].class == "videoArea-position1") {
          this.videoPostion[key].height = height2;
          this.videoPostion[key].width = width2;
        }
      }
      this.updateQuality();
    },
    selectPlayStyle() {
      if (this.isLeave || this.isDestry) {
        return;
      }
      //        //opType:0 真直播   opType：3 伪直播    opType:2 第三方拉流   opType:1第三方推流
      // // 1:结束  0：开始 2：有流
      // pushStreamStatus : 0开始  其他：结束
      // if (this.liveStartStatus == 2) {
        console.log(this.defaultSource, "this.defaultSource")
        console.log(this.playerConfig.source, "playerConfig")
      if (
        (this.opType == 2 || this.opType == 3 || this.opType == 1) &&
        this.used == 0 &&
        !this.playerConfig.source
      ) {
        console.log(this.opType, "this.opType")
        console.log(this.pushStreamStatus, "pushStreamStatus")
        //如果是预约主播源，发布视频，否则获取直播源，当发布直播源后关闭视频流，获取直播源
          // if(this.defaultSource !== 0 || this.pushStreamStatus == 0){
          //   console.log("直播流...")
            this.stopSubLive();
            this.getLivePlayInfo();
          // } else {
          //   console.log("主播源...")
          //   this.getLiveStream();
          // }
      }
      const isSub =
        this.liveSubScription &&
        this.liveSubScription.getConnectionState &&
        this.liveSubScription.getConnectionState() == "connected"
          ? true
          : false;
      if ((this.opType == 0 || this.opType == -1) && !isSub) {
        this.stopVuePlayer();
        this.stopSubLive();
        this.getLiveStream();
      }
    },
    handelVideo(info, type) {
      if (type == "show" || type == "hide") {
        info.isShow = !info.isShow;
      } else {
        let width1 = JSON.parse(JSON.stringify(this.videoPostion.live.width));
        let height1 = JSON.parse(JSON.stringify(this.videoPostion.live.height));
        const classs1 = JSON.parse(
          JSON.stringify(this.videoPostion.live.class)
        );
        this.videoPostion.live.class = JSON.parse(
          JSON.stringify(this.videoPostion.local.class)
        );
        this.videoPostion.live.width = JSON.parse(
          JSON.stringify(this.videoPostion.local.width)
        );
        this.videoPostion.live.isShow = true;
        this.videoPostion.live.height = this.videoPostion.local.height;
        this.videoPostion.local.width = width1;
        this.videoPostion.local.height = height1;
        this.videoPostion.local.class = classs1;
        this.videoPostion.local.isShow = true;
        console.log(this.videoPostion);
      }
      this.updateQuality();
    },
    loadNedePlayerWasm() {
      this.playerConfig.nodePlayerWasmUrl = {
        player: `${["production", "dev"].includes(process.env.NODE_ENV) ? "/cla/" : ""}static/nodeplayerWasm/NodePlayer.min.js`,
      };
    },
    init() {
      console.log(this.videoInputDeviceId,"videoInputDeviceId 发布本地视频");
      console.log(this.AudioInputDeviceId, "AudioInputDeviceId 发布本地视频");
      //console.log(this.$store.getters.videoInputDeviceId, "getters videoInputDeviceId 发布本地视频");
      Bus.$emit("showStartTips");
      this.logger.info({ code: 2023, message: "开始发布本地视频" });
      if (this.localPublication && this.localPublication.stop) {
        this.localPublication.stop();
      }
      //console.log(this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream, '.....')
      console.log(this.publishStream && this.publishStream.getVideoTracks(), "getVideoTracks");
      console.log(this.publishStream && this.publishStream.getAudioTracks(), "getAudioTracks");
      // this.logger.info({
      //   code: 2024,
      //   message: this.publishStream.getAudioTracks,
      // });
      // this.logger.info({
      //   code: 2025,
      //   message: this.publishStream.getVideoTracks,
      // });
      if (this.selfVideoStatus == "inactive" && this.publishStream && this.publishStream.getVideoTracks()[0]) {
        this.publishStream.getVideoTracks()[0].enabled = false;
      }
      console.log(this.selfAudioStatus, "this.selfAudioStatus");
      console.log(this.rtcClient.RTCRoom, 'RTCRoom')
      console.log(this.liveConfig.video_source_ratio)
      console.log(this.selfType)

      this.rtcClient.RTCRoom.publishLocalStream(
        {
          VideoInputDeviceId:
            this.liveConfig.video_source_ratio == 1 && this.selfType != 3
              ? false
              : this.videoInputDeviceId,
          AudioInputDeviceId: this.AudioInputDeviceId,
        },
        {
          video: {
            deviceId: this.videoInputDeviceId,
          },
        }
      )
        .then((res) => {
          this.logger.info({ code: 2026, message: res });
          console.log('发布成功')
          this.setSinkId();
          document.getElementById("local").srcObject = res.streamsrc;
          // debugger
          // console.log(res.publication.getSenders(), "返回流");
          this.localPublication = res.publication;
          //写入当前流信息
          sessionStorage.setItem("selfStreamId", res.publication.id);
          // Bus.$emit("selfStreamId", res.publication.id)
          this.setSendResolution();
          // this.addTrackEvent();
          this.addVideoTrackEvent();
          this.addAudioTrackEvent();
          setTimeout(() => {
            if (this.isDestry) {
              return;
            }
            if (this.selfAudioStatus == "inactive") {
              this.muteMic();
            }
            if (this.selfVideoStatus == "inactive") {
              this.muteCamera();
            }
          }, 1000);
        })
        .catch((err) => {
          this.logger.info({ code: 2027, message: err });
          console.log(err, "发布失败");
          this.subOrPubErrTips();
        });
    },
    addVideoTrackEvent() {
      if (this.publishStream && this.publishStream.getVideoTracks()[0]) {
        let videoTrack = this.publishStream.getVideoTracks()[0];
        videoTrack.addEventListener("ended", (info) => {
          const tips =
            this.videoStatus == "active"
              ? `${this.$t("localvideo.device")}【${
                  info.currentTarget.label
                }】${this.$t("localvideo.videoDeviceOpenErr")}`
              : `${this.$t("localvideo.device")}【${
                  info.currentTarget.label
                }】${this.$t("localvideo.DeviceCloseErr")}`;
          const isActive = this.videoStatus == "active" ? true : false;
          this.errTips(tips, isActive);
          this.publishStream.removeTrack(videoTrack);
          this.rtcClient.RTCRoom.webrtc.publishLocal.publication.mute("video");
          setTimeout(() => {
            if (this.isDestry) {
              return;
            }
            const mediaStatus = this.$store.getters.selfParticipant.mediaStatus;
            mediaStatus.video = null;
            this.$store.commit(
              "SET_SELFPARTICIPANT",
              Object.assign(this.$store.getters.selfParticipant, {
                mediaStatus,
              })
            );
            console.log(this.$store.getters.selfParticipant);
          }, 1000);
        });
      }
    },
    addAudioTrackEvent() {
      if (this.publishStream && this.publishStream.getAudioTracks()[0]) {
        let audioTrack = this.publishStream.getAudioTracks()[0];
        audioTrack.addEventListener("ended", (info) => {
          let tips =
            this.audioStatus == "active"
              ? `${this.$t("localvideo.device")}【${
                  info.currentTarget.label
                }】${this.$t("localvideo.audioDeviceOpenErr")}`
              : `${this.$t("localvideo.device")}【${
                  info.currentTarget.label
                }】${this.$t("localvideo.DeviceCloseErr")}`;
          const isActive = this.audioStatus == "active" ? true : false;
          this.errTips(tips, isActive);
          this.publishStream.removeTrack(audioTrack);
          this.rtcClient.RTCRoom.webrtc.publishLocal.publication.mute("audio");
          setTimeout(() => {
            if (this.isDestry) {
              return;
            }
            const mediaStatus = this.$store.getters.selfParticipant.mediaStatus;
            mediaStatus.audio = null;
            this.$store.commit(
              "SET_SELFPARTICIPANT",
              Object.assign(this.$store.getters.selfParticipant, {
                mediaStatus,
              })
            );
            console.log(this.$store.getters.selfParticipant);
          }, 1000);
        });
      }
    },
    addTrackEvent() {
    },
    errTips(tips, isActive) {
      let tipsObj = {
        confirmButtonText: this.$t("video.立即设置"),
        customClass: "tip-alert text-left",
        showCancelButton: false,
      };
      if (!isActive) {
        tipsObj = Object.assign(tipsObj, {
          showCancelButton: true,
          cancelButtonText: this.$t("video.我知道了"),
        });
      }
      this.$confirm(tips, this.$t("video.提示"), tipsObj)
        .then(() => {
          Bus.$emit("openSetting");
        })
        .catch(() => {});
    },
    updatePicQuality() {
      if (this.signalStatus > 0) {
        this.setSendResolution();
      }
    },
    async updateQuality() {
      if (this.isShowNodePlayer) {
        this.setQualityUrl();
      } else {
        const quality = await this.getQuality();
        if (!this.preQuality || quality.width === this.preQuality.width) {
          return;
        }
        this.getLiveStream();
      }
    },
    async getQuality() {
      await this.$nextTick();
      let el = document.querySelector(".videoArea-position1 > #live");
      if (!el) {
        el = document.querySelector(".videoArea-position1 > #Vue_Player");
      }
      if (el && (this.isFullScreen || this.ischangearea)) {
        return {};
      } else {
        return {
          width: 640,
          height: 360,
        };
      }
    },
    // 切换分辨率地址
    async setQualityUrl() {
      this.logger.info({ code: 2028, message: this.playUrls });
      if (!this.playUrls) return;
      const quality = await this.getQuality();
      console.warn(quality, "quality");
      const urls = this.playUrls;
      let url = null;
      if (quality.width) {
        url = urls.FD;
      } else {
        url = urls.HD || urls.SD || urls.FD;
      }
      if (this.preUrl == url) return;
      this.preUrl = url;
      this.$refs.VueAliplayerV2.loadByUrl(url);
      this.logger.info({ code: 2028, message: this.url });
    },
    setSendResolution() {
      if (this.publishStream && this.publishStream.getVideoTracks()[0]) {
        let videoTrack = this.publishStream.getVideoTracks()[0];
        let videoTrackSettings = videoTrack.getSettings(),
          videoTrackCapabilities = videoTrack.getCapabilities
            ? videoTrack.getCapabilities()
            : null;
        let videoMaxResolution = videoTrackCapabilities
          ? videoTrackCapabilities.width.max
          : videoTrackSettings
          ? videoTrackSettings.width
          : null;

        let constraints = Resolutions[0];
        const preConstraints =
          JSON.parse(sessionStorage.getItem("mediaSelectConstraints")) ||
          this.getCameraResolution ||
          {};
        if (preConstraints && preConstraints.width <= constraints.width) {
          constraints = preConstraints;
        }
        if (videoMaxResolution < constraints.width) {
          constraints = Resolutions.find((v) => v.width <= videoMaxResolution);
        }

        // 信号低时触发
        // if (this.signalStatus > 0) {
        //   const picMode = sessionStorage.getItem('mediaSelectPicQuality') >> 0
        //   if (picMode == 2) {
        //     // 流畅优先降分辨率
        //     const index = Resolutions.findIndex(v => v.width === constraints.width)
        //     if (index < Resolutions.length - 1) {
        //       constraints = Resolutions[index + 1]
        //     }
        //   } else {
        //     // 画质优先降帧率
        //     const supports = navigator.mediaDevices.getSupportedConstraints()
        //     if (supports['frameRate']) {
        //       constraints.frameRate = 25
        //     }
        //   }
        //   console.warn('lower signal ', constraints);
        // }
        this.rtcClient.RTCRoom.webrtc.setApplyConstraints(
          this.publishStream,
          constraints
        );
        this.setSendMaxBitrate(constraints.width);
        // const picMode = sessionStorage.getItem('mediaSelectPicQuality') >> 0
        // this.setQualityType(picMode)
      }
    },
    setQualityType(data) {
      if (!this.publication) return;
      this.publication.getSenders().forEach(async (sender) => {
        if (sender.track.kind == "video") {
          const params = sender.getParameters();
          params.degradationPreference =
            data === 2 ? "maintain-framerate" : "maintain-resolution";
          sender.setParameters(params);
        }
      });
    },
    //默认360P
    setSendMaxBitrate(value) {
      const maxBitrate =
        value == 1920 ? 2000000 : value == 1280 ? 1500000 : 600000;
      // sessionStorage.setItem("maxBitrate", maxBitrate)
      this.chooseMaxBitrate = maxBitrate;
      if (!this.localPublication) return;
      this.localPublication.getSenders().forEach(async (sender) => {
        if (sender.track.kind == "video") {
          const params = sender.getParameters();
          params.encodings.forEach((encoding) => {
            encoding.maxBitrate = maxBitrate;
            encoding.maxFramerate = 30;
          });
          console.log(params, "params...")
          await sender.setParameters(params);
        }
      });
    },
    scaleBitrate(value) {
      // debugger
      if (value) {
        console.log(this.localPublication, "this.localPublication....");
        if (!this.localPublication) return;
        this.shareDesk = true;
        this.localPublication.getSenders().forEach(async (sender) => {
          if (sender.track.kind == "video") {
            const params = sender.getParameters();
            console.log(params, "params....");
            params.encodings.forEach((encoding) => {
              encoding.maxBitrate = 600000;
              encoding.maxFramerate = 30;
            });
            await sender.setParameters(params);
          }
        });
        const videoTrack = this.publishStream && this.publishStream.getVideoTracks()[0];
        console.log(videoTrack, "this.localPublication videoTrack...")
        if (!videoTrack) return;
        console.log(this.maxResolution, "this.maxResolution...")
        const constraints = {
          width: { max: 640 },
          height: { max: 360 },
        };

        videoTrack
          .applyConstraints(constraints)
          .then(function () {
            console.info("分辨率已降低", constraints);
          })
          .catch(function (error) {
            console.error("无法应用约束条件：" + error);
          })
          .catch(function (error) {
            console.error("无法获取本地视频流：" + error);
          });
      }
    },
    /**
     * 关闭共享10S后不共享恢复分辨率
     */
    closeShareLayout() {
      this.shareDesk = false;
      setTimeout(() => {
        if (this.isDestry) {
          return;
        }

        if (!this.shareDesk) {
          if (!this.localPublication) return;
          const videoTrack = this.publishStream.getVideoTracks()[0];
          console.log(videoTrack, "this.publishStream restore...")
          if (!videoTrack) return;
          console.log(this.maxResolution, "this.maxResolution restore...")
          let  preConstraints = this.maxResolution
          if(sessionStorage.getItem("mediaSelectConstraints")){
            preConstraints = JSON.parse(sessionStorage.getItem("mediaSelectConstraints"))
          }
          const constraints = {
            width: preConstraints.width,
            height: preConstraints.height
          };

          videoTrack
            .applyConstraints(constraints)
            .then(() => {
              console.info("分辨率已恢复", constraints);
              this.logger.info({ code: 2051, message: constraints });
            })
            .catch((error) => {
              console.error("无法应用约束条件：" + error);
              this.logger.info({ code: 2052, message: error });
            })
            .catch((error) => {
              console.error("无法获取本地视频流：" + error);
              this.logger.info({ code: 2053, message: error });
            });

          const constraintsMax = {
            width: { max: preConstraints.width},
            height: { max: preConstraints.height}
          };
          videoTrack
            .applyConstraints(constraintsMax)
            .then(function () {
              console.info("分辨率已恢复", constraintsMax);
              this.logger.info({ code: 2054, message: constraintsMax });
            })
            .catch(function (error) {
              console.log("无法应用约束条件：" + error);
              this.logger.info({ code: 2055, message: error });
            })
            .catch(function (error) {
              console.log("无法获取本地视频流：" + error);
              this.logger.info({ code: 2056, message: error });
            });
            this.setSendMaxBitrate(preConstraints.width)
        }
      }, 10000);
    },
    setSinkId() {
      if (this.AudioOutputDeviceId) {
        // if (document.getElementById("local")) {
        //   document.getElementById("local").setSinkId(this.AudioOutputDeviceId);
        // }
        if (document.getElementById("live")) {
          document.getElementById("live").setSinkId(this.AudioOutputDeviceId);
        }
      }
    },
    getReceiverCsrc (subscription) {
      if (this.getReceiverCsrcTimer) {
        clearTimeout(this.getReceiverCsrcTimer)
        this.getReceiverCsrcTimer = null
      }
      let baseUrl = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'test' ? '/cla/' : '/';
      if (!this.getReceiverCsrcWorker) {
        this.getReceiverCsrcWorker = new Worker(`${baseUrl}getReceiverCsrc_worker.js`);
      }
      this.getReceiverCsrcTimer = setInterval(() => {
        if (subscription) {
          let ReceiversCsrc = subscription.getReceivers();
          ReceiversCsrc.forEach(async ReceiversCsrcInfo => {
						if (ReceiversCsrcInfo.track.kind == "audio") {
							var audioCsrcs = ReceiversCsrcInfo.getContributingSources();
						}
						this.getReceiverCsrcWorker.postMessage({
							status: 'start',
							audioCsrcs,
							browser: sysInfo().runtime.name
						})
					})
        }
      }, 300)
      this.getReceiverCsrcWorker.onmessage = (info) => {
        if(info.data.type == 'audio'){
          // console.log(info.data, 'voiceStimulationChange')
          Bus.$emit("voiceStimulationChange", info.data);
          // this.voiceStimulationChange(info.data);
        }
      }
    },
    async getLiveStream(isForceSub) {
      if (this.isLeave || this.isDestry) {
        return;
      }

      const quality = await this.getQuality();
      this.logger.info({ code: 2030, message: "开始订阅直播流" });
      console.log('dingyue....')
      if (this.rtcClient.RTCRoom && this.rtcClient.RTCRoom.remoteMixStream) {
        const liveStream = this.rtcClient.RTCRoom.remoteMixStream.find(
          (info) => {
            return info.id.split("-")[1] == "live2";
          }
        );

        console.log(liveStream, 'liveStream')
        this.logger.info({ code: 2044, message: liveStream });
        console.log(this.isSubing, "this.isSubing", ' ,isForceSub:', isForceSub);
        if (liveStream && (!this.isSubing || isForceSub)) {
          this.maxResolution = liveStream.settings.video.resolution;
          this.isSubing = true;
          this.preQuality = quality;
          console.warn(quality, "quality");
          const params = quality.width
            ? {
                resolution: quality,
                // , frameRate:25
              }
            : {
                resolution: {
                  width: this.maxResolution.width,
                  height: this.maxResolution.height,
                },
              };
          const codecsName = this.device.isFireFox ? "vp8" : "h264";
          //console.log(this.liveSubScription.getConnectionState, 'sub流状态');
          if (
            !this.liveSubScription ||
            !this.liveSubScription.getConnectionState ||
            this.liveSubScription.getConnectionState() != "connected"
          ) {
            if (this.liveSubScription && this.liveSubScription.stop) {
              this.liveSubScription.stop();
            }

            const reqSeq = ++this.subLiveReconnect.seq;
            console.log('this.rtcClient.RTCRoom.subscribeStream reqSeq:',  reqSeq);
            this.rtcClient.RTCRoom.subscribeStream(
              liveStream,
              { codecs: [{ name: codecsName }], ...params },
              true
            )
              .then((res) => {
                this.logger.info({ code: 2031, message: res });
                if (this.isLeave || this.isDestry) {
                  this.clearSubLiveTimer();
                  return;
                }
                if (reqSeq !== this.subLiveReconnect.seq) {
                  console.log('reqSeq !== this.subLiveReconnect.seq, reqSeq:', reqSeq, ' ,this.subLiveReconnect.seq:', this.subLiveReconnect.seq);
                  res.subscription && res.subscription.stop && res.subscription.stop();
                  return;
                }
                this.isSubing = false;
                this.liveStream = res;
                const eventName = ["error", "ended"];
                if (this.liveSubScription) {
                  console.log('remove liveSubScription', this.liveSubScription.id);
                  eventName.forEach((event) => {
                    this.liveSubScription.clearEventListener(`${event}`)
                  });
                  this.liveSubScription = undefined;
                }

                this.$store.commit("SET_SHARESUBSCRIPTION", res.subscription);
                this.liveSubScription = res.subscription;
                console.log('set liveSubScription', this.liveSubScription, this.subLiveReconnect.timer);
                document.getElementById("live").srcObject = res.stream.mediaStream;
                this.getReceiverCsrc(res.subscription)
                //改大小窗声音显示不同步问题
                //this.closeSpeaker = false;

                eventName.forEach((event) => {
                  res.subscription.addEventListener(`${event}`, () => {
                    if (this.isLeave || this.isDestry) {
                      this.clearSubLiveTimer();
                      return;
                    }
                    console.log(
                      "%c 订阅live流重连, 因为接收到事件:" + event + ",recollectTimeCount:" + this.recollectTimeCount,
                      "color:red;font-size:16px"
                    );
                    this.logger.info({ code: 2036, message: "%c 订阅live流重连, 因为接收到事件:" + event + ",recollectTimeCount:" + this.recollectTimeCount });
                    if (!this.recollectTimer) {
                      this.setRecollectTimer();
                    }

                    // 订阅流重连
                    this.clearSubLiveTimer();
                    this.subLiveReconnect.timer = setInterval(async () => {
                      if (this.isDestry) {
                        this.clearSubLiveTimer();
                        return;
                      }

                      console.log(
                        "trigger subLiveReconnect timer callback",
                        this.liveSubScription && this.liveSubScription.getConnectionState && this.liveSubScription.getConnectionState()
                      );

                      if (
                        this.liveSubScription &&
                        this.liveSubScription.getConnectionState
                      ) {
                        if (this.liveSubScription.getConnectionState() != "connected") {
                          //debugger
                          console.log(
                            "%c 10s后重新订阅live流中" + ",recollectTimeCount:" + this.recollectTimeCount,
                            "color:red;font-size:16px"
                          );
                          this.getLiveStream(true);
                          this.logger.info({ code: 2047, message: '重新订阅' + this.recollectTimeCount + '次' });
                        } else {
                          this.clearSubLiveTimer();
                        }
                      }
                    }, 10000);

                    console.log('getLiveStream set this.subLiveReconnect.timer', this.subLiveReconnect.timer);
                  });
                });
              })
              .catch((err) => {
                this.logger.info({ code: 2032, message: err });
                console.log(err, "订阅失败");
                this.subOrPubErrTips();
              });
          } else {
            console.log({ video: params }, '无状态');
            this.isSubing = false;
            this.liveSubScription.applyOptions({ video: params });
          }
        }
      }
    },
    stopSubLive() {
      if (this.liveStream && this.liveStream.subscription) {
        this.isSubing = false;
        this.liveStream.subscription.stop();
        this.liveStream.subscription = null;
        this.liveStream = null;
        this.logger.info({ code: 2033, message: "结束订阅直播流" });
      }
    },
    stopVuePlayer() {
      this.playerConfig.source = null;
      if (this.$refs.VueAliplayerV2) {
        this.$refs.VueAliplayerV2.dispose();
      }
      this.isShowNodePlayer = false;
      this.logger.info({ code: 2034, message: "播放器销毁" });
    },
    getCvMcRoomMessage(msg) {
      if (this.isDestry) {
        return;
      }
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7125: {
          this.disposeCustomMessage_7125(msg.requestData);
          break;
        }
        case 7127: {
          this.disposeCustomMessage_7127(msg.requestData);
        }
      }
    },
    /**获取拉流地址信息 */
    getLivePlayInfo() {
      if (this.isLeave || this.isDestry) {
        return;
      }
      this.isShowNodePlayer = true;
      if (!this.pseudoLiveData) return;
      this.disposeUrlFunc(this.pseudoLiveData);
    },
    async disposeUrlFunc(data) {
      console.log(data,"disposeUrlFunc");
      let _live_time_delay = "FLV";
      let sourceTempObj = {};
      let _audioSourceUrl = "";
      if (!_live_time_delay) _live_time_delay = "FLV";
      if (sessionStorage.getItem("is_rts") === "true") {
        _live_time_delay = "RTS";
      }
      console.log(_live_time_delay, "_live_time_delay")
      switch (_live_time_delay) {
        case "HLS": {
          let _hls = data.hls;
          sourceTempObj = await this.videoFormatTransition(_hls);
          _audioSourceUrl = this.judgeHttps(_hls.audio);
          break;
        }
        case "RTS": {
          let _rts = data.rts;
          sourceTempObj = await this.videoFormatTransition(_rts);
          _audioSourceUrl = this.judgeHttps(_rts.audio);
          break;
        }
        case "FLV": {
          let _flv = data.flv;
          sourceTempObj = await this.videoFormatTransition(_flv);
          _audioSourceUrl = this.judgeHttps(_flv.audio);
          break;
        }
      }
      if (_live_time_delay === "FLV") {
        this.playerConfig.roomOptions = {
          streamType: "flv",
        };
      } else {
        this.playerConfig.roomOptions = {
          streamType: _live_time_delay.toLowerCase(),
        };
      }
      this.$refs.VueAliplayerV2 &&
        this.$refs.VueAliplayerV2.dispose &&
        this.$refs.VueAliplayerV2.dispose();
      if (this.source == JSON.stringify(sourceTempObj)) return;
      this.playerConfig.options.mediaType = "video";
      let _this = this;
      this.disposeUrlFuncTimer = setTimeout(() => {
        if (this.isDestry) {
          return;
        }
        _this.playerConfig.source = JSON.stringify(sourceTempObj);
        setTimeout(() => {
          if (this.isDestry) {
            return;
          }
          this.setQualityUrl();
          this.$refs.VueAliplayerV2.play();
        }, 1000);
        _this.playerConfig.audioSource = _audioSourceUrl;
      }, 1000);
      // }
    },
    async videoFormatTransition(videoStream) {
      console.log(videoStream, "videoStream.....")
      let retObj = {};
      if (videoStream.ld) retObj.FD = this.judgeHttps(videoStream.ld);
      if (videoStream.hd) retObj.SD = this.judgeHttps(videoStream.hd);
      if (videoStream.ud) retObj.HD = this.judgeHttps(videoStream.ud);
      this.playUrls = retObj;
      console.log(retObj, "videoFormatTransition.....")
      const quality = await this.getQuality();
      console.log(quality, "getQuality.....")
      if (quality.width) {
        return {
          FD: retObj.FD || retObj.SD || retObj.HD,
        };
      } else {
        return {
          HD: retObj.HD || retObj.SD || retObj.FD,
        };
      }
    },
    /**判断当前是否当前是否是https访问 */
    judgeHttps(url) {
      // window.location.protocol === "https:"&&
      if (url) {
        url = url.replace(/http:/g, "https:");
      }
      return url;
    },
    disposeCustomMessage_7125(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "pushStream": {
            console.log(requestData, "pushStream");

            if (
              requestData.pullStreamUrl &&
              requestData.pullStreamUrl.code === 200
            ) {
              this.pseudoLiveData = requestData.pullStreamUrl.data;
              console.log('selectPlayStyle 7125')
              this.selectPlayStyle();
            }
            break;
          }
        }
      }
    },
    disposeCustomMessage_7127(requestData) {
      console.log("video control.....")
      switch (requestData.event) {
        case "assistant_webcast_stream_status": {
          this.$store.commit("SET_OPTYPE", requestData.opType);
          this.$store.commit("SET_STREAMSTATUS", requestData.streamStatus);
          this.$store.commit("SET_USED", requestData.used);
          if (requestData.opType === 0) {
            //opType:0 真直播   opType：3 伪直播    opType:2 第三方拉流
            return;
          }
          if (
            requestData.opType == 2 &&
            requestData.streamStatus == 0 &&
            requestData.used == 0
          ) {
            /**
             * opType:2是否存在第三方拉流
             * streamStatus: 0有流 1没有流 2正在拉流,
             * used: 0拉流中 1未拉流
             */
            this.$store.commit("SET_THIRDPUSHSTREAMSTATUS", true);
            this.isThirdStream = true;
          } else if (requestData.opType == 2 && requestData.streamStatus == 1) {
            this.$store.commit("SET_THIRDPUSHSTREAMSTATUS", false);
            this.isThirdStream = false;
          }
          // if (requestData.streamStatus == 2 || requestData.streamStatus == 0) {
          //   this.isShowNodePlayer = true;
          //   this.getLivePlayInfo();
          // } else {
          //   this.playerConfig.source = null;
          //   if (this.$refs.VueAliplayerV2) {
          //     this.$refs.VueAliplayerV2.dispose();
          //   }
          //   this.isShowNodePlayer = false;
          // }
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "pushStream": {
            if (requestData.code === 200) {
              this.pseudoLiveData = requestData.data;
              // this.getLivePlayInfo(requestData.data);
            }
            break;
          }
          case "pushStreamStatus": {
            this.$store.commit("SET_PUSHSTREAMSTATUS", requestData.type);
            console.log(requestData.type, "直播状态");
            if (`${requestData.type}` === `0`) {
              let _pullStreamUrl = requestData.pullStreamUrl;
              if (_pullStreamUrl) {
                // this.disposeUrlFunc(_pullStreamUrl.data);
              }
            } else {
              console.log("结束直播");
              this.playerConfig.source = null;
              if (this.$refs.VueAliplayerV2) {
                this.$refs.VueAliplayerV2.dispose();
              }
              this.logger.info({code: 2049, message: "pushStreamStatus结束直播"})
            }
            break;
          }
          case "liveStatus": {
            this.$store.commit("SET_LIVEROOMSTATUS", requestData.type);
            if (`${requestData.type}` === "2") {
              this.playerConfig.options.isLive = true;
              let _mode = requestData.live.mode;
              if (`${_mode}` === "0") {
                this.playerConfig.options.mediaType = "video";
                this.videoOrAudio = _mode;
              } else if (`${_mode}` === "1") {
                this.playerConfig.options.mediaType = "audio";
                this.videoOrAudio = _mode;
              }
            }
            break;
          }
        }
      }
    },
    changeMicStatus() {
      // 2.0.10 允许嘉宾与主播关闭音视频设备
      if (
        this.audioStatus == "inactive" &&
        this.avctl == 0 &&
        this.authAudio == 0
      )
        return;
      const status = this.audioStatus == "active" ? "inactive" : "active";
      this.rtcClient.RTCRoom.muteParticipant(
        this.userInfo.uid,
        this.userInfo.cid,
        status
      ).then(() => {
        this.$store.commit("SET_SELFAUDIOSTATUS", status);
      });
    },
    muteCamera() {
      this.rtcClient.RTCRoom.handleParticipantCamera(
        this.userInfo.uid,
        this.userInfo.cid,
        "inactive"
      ).then(() => {
        this.$store.commit("SET_SELFVIDEOSTATUS", "inactive");
      });
    },
    muteMic() {
      this.rtcClient.RTCRoom.muteParticipant(
        this.userInfo.uid,
        this.userInfo.cid,
        "inactive"
      ).then(() => {
        this.$store.commit("SET_SELFAUDIOSTATUS", "inactive");
      });
    },
    fullScreen() {
      let isFull =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (isFull) {
        this.isFullScreen = false;
        //document.exitFullscreen();
        exitFullscreen();
      } else {
        this.isFullScreen = true;
        fullScreen(document.querySelector(".video-container"));
      }
    },
    changeSpeakerStatus() {
      if (this.$refs.liveRef) {
        this.closeSpeaker = !this.closeSpeaker;
        this.$refs.liveRef.muted = this.closeSpeaker;
      }
      if (this.$refs.VueAliplayerV2) {
        this.closeSpeaker = !this.closeSpeaker;
        this.closeSpeaker
          ? this.$refs.VueAliplayerV2.mute()
          : this.$refs.VueAliplayerV2.unMute();
      }
    },
    pushStreamUrl(info) {
      let streamType = info.streamType;
      // TODO: 获取徐老师的流地址
      return pushStreamUrl(this.liveId, this.liveToken)
        .then(async (res) => {
          if (res && res.data) {
            let streamData = JSON.parse(res.data).data;
            streamType =
              streamType ||
              this.liveStreamType[streamData.live_time_delay].toLowerCase() ||
              "flv";
            let returnUrl = {
              playAduioUrl: this.judgeHttps(streamData[streamType].audio),
              playAVUrl: await this.videoFormatTransition(
                streamData[streamType]
              ),
            };
            if (returnUrl) return returnUrl;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onPlay() {
      this.closeSpeaker = false;
    },
    // 订阅或发布失败提示
    subOrPubErrTips() {
      this.$alert(this.$t("video.netOrDeviceErrTips"), {
        title: this.$t("video.网络设备异常"),
        customClass: "tip-alert text-left",
        confirmButtonText: this.$t("video.知道了"),
        callback: () => {},
      });
    },
  },
};
</script>

<style lang="scss">
.videoArea-container {
  // width: 100%;
  background-color: $asiderightbg-color;
  display: flex;
  justify-content: space-around;
  // padding: 8px 0px;
  height: 158px;
  align-items: center;

  // position: relative;
  .close_camera {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;
    background: #000;
    img {
      filter: drop-shadow(#acb2bf 80px 0);
      -webkit-filter: drop-shadow(#acb2bf 80px 0);
      transform: translateX(-80px);
    }
  }

  .local-btn {
    position: absolute;
    bottom: 6px;
    height: 26px;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 12px);
    margin: auto;
    left: 6px;
    right: 6px;

    // padding: 6px;
    span,
    .local-icon-container {
      background-color: #191d28;
      height: 26px;
      display: inline-block;
      width: 50px;
      line-height: 26px;
      border-radius: 4px;
      opacity: 0.5;
      color: $white-color;
    }

    .local-icon-container {
      width: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .local-icon {
        overflow: hidden;
        height: 20px;
        // .micInactive,
        // .cameraInactive {
        //   filter: drop-shadow($grey-color 80px 0);
        //   -webkit-filter: drop-shadow($grey-color 80px 0);
        //   transform: translateX(-80px);
        // }
        // .micActive,
        // .cameraActive {
        //   filter: drop-shadow($green2-color 80px 0);
        //   -webkit-filter: drop-shadow($green2-color 80px 0);
        //   transform: translateX(-80px);
        // }
        // .disabled {
        //   filter: drop-shadow(rgba(138, 143, 153, 0.4) 80px 0);
        //   -webkit-filter: drop-shadow(rgba(138, 143, 153, 0.4) 80px 0);
        //   transform: translateX(-80px);
        // }
      }
    }
  }

  .videoArea-position1 {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;

    video {
      width: 100%;
      height: 100%;
    }
  }

  .videoArea-position2 {
    height: auto;
    width: auto;
    position: absolute !important;
    left: 16px;
    top: 14px;
    z-index: 2;
    // background: #000;
  }

  .video-fullscreen {
    position: absolute;
    right: 50%;
    top: 50%;
    transform: translate(100%, -50%);
    width: 40px;
    height: 40px;
    background-color: rgba($color: #000000, $alpha: 0.5);
    border-radius: 40px;
    line-height: 40px;
    z-index: 100;

    img {
      width: 12px;
      height: 12px;
    }
  }

  .live-speaker {
    position: absolute;
    right: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    background-color: rgba($color: #000000, $alpha: 0.5);
    border-radius: 40px;
    line-height: 40px;
    z-index: 100;

    img {
      width: 12px;
      height: 12px;
    }
  }

  .fullscreen-exit {
    width: 50px;
    height: 50px;
    line-height: 58px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .fullscreen-speaker {
    width: 50px;
    height: 50px;
    line-height: 58px;
    right: 50px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .divider {
    width: 2px !important;
    height: 11px !important;
    opacity: 0.8 !important;
    background-color: #999999 !important;
  }
}

@media screen and (min-width: 100px) {
  .big-play {
    width: 30px;
  }

  .player-loading-image {
    transform: scale(0.1);
    left: calc(-50%);
    top: calc(-50% + 18px);
  }

  .change_pause,
  .change_paly,
  .change_paly:hover,
  .change_pause:hover {
    background-size: 40% !important;
    bottom: 1px;
    position: absolute;
  }
}

.Vue263playerSlots,
.VueAliplayerV2-hover {
  position: absolute;
  width: 100%;
  height: 100%;
  // z-index: 1111111;
  background: #999999;
  left: 0px;
  top: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 1;
  opacity: 0.7;
}

.Vue263playerSlots {
  img {
    object-fit: contain;
  }
  background: #000;
}

.VueAliplayerV2-hover {
  display: none;
}

.VueAliplayerV2-hover {
  background-color: rgba($color: #000000, $alpha: 0.1);

  div {
    overflow: hidden;

    img {
      filter: drop-shadow(#d7dfef 80px 0);
      -webkit-filter: drop-shadow(#d7dfef 80px 0);
      transform: translateX(-80px);
    }
  }
}

.show_video {
  width: 30px !important;
  height: 30px !important;

  > div > div {
    display: none;
  }

  > video {
    display: none;
  }
}

.local-name,
.live-name {
  width: 25px;
  height: 12px;
  // background: #ffffff;
  border-radius: 2px;
  // opacity: 0.8;
  position: absolute;
  z-index: 1;
  height: 18px;
  top: 0px;
  color: #ea494b;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
}

.live-name-right {
  span {
    background-color: #191d28;
    height: 26px;
    display: inline-block;
    width: 50px;
    line-height: 26px;
    border-radius: 4px;
    opacity: 0.5;
    color: $white-color;
  }
}

.live-name-right {
  left: 6px;
  bottom: 6px;
  top: inherit;
  position: absolute;
}

.videoArea-position1:hover .VueAliplayerV2-hover,
.videoArea-position2:hover .VueAliplayerV2-hover {
  display: flex;
}

.borderRadius4 {
  border-radius: 4px;
  // background: #21242e;
}

.control_change_playstatus_portrait {
  z-index: 100;
}

.over-control {
  position: absolute;
  width: 100px;
  height: 50px;
  z-index: 400;
}

.full-control {
  right: 10px;
  bottom: 10px;
}
.full-control-audio {
  right: 20px;
  bottom: 70px!important;
}
</style>
